'use strict';
import EventManager from '../../externals/bss-package-event-manager/js/event-manager.js';
import logger from '@main/externals/bss-package-logger/js/logger';
export function createController(_a) {
    var marketComponents = _a.marketComponents, BSSControllerToolbox = _a.BSSControllerToolbox, descriptionConfig = _a.descriptionConfig;
    /**
     * @private
     * @desc initialize BSSControllerInternal object, gets the flow configuration
     */
    var _BSSControllerToolbox = null;
    var _eventManager; // eslint-disable-line no-unused-vars
    /**
     * BSSController
     */
    return /** @class */ (function () {
        /**
         * @desc BSSController constructor
         * @param {String} [environment=null] environment
         * @param {Object} [resolutionsConfig=null] resolutionsConfig
         * @param {String} [version='prod'] version
         * @param {String} [elementType='null'] base flow type possible options 'simulator', 'onlineApproval'
         * @param {String} [gaKEY=null] contains GA unique session key.
         * @param {'body' | 'popup' | ''} [location=''] injection location of the element
         * @param {Object} [flowProps=null] injection flowProps of the element
         * @param {Function} [setFlowConfigurationCallback=null] injection add listeners function of the element
         * @param {string} [quoteId=null] quoteId value
         * @param {Function} [setInsideWidgetQuoteId=null] injection add set quoteId function of the element
         * @param {String} [theme=null] theme
         * @param {String} [origin=null] origin for tagging
         * @param {Boolean} [isLocaleAphelia=null] aphelia for local
         * @param {Boolean} [standalone=null] standalone cf
         */
        function BSSController(environment, resolutionsConfig, version, elementType, gaKEY, location, flowProps, setFlowConfigurationCallback, quoteId, setInsideWidgetQuoteId, isWidgetInWidget, cfx, theme, origin, isLocaleAphelia, initConfiguration, standalone) {
            /**
             * @private
             * @desc initialize _BSSControllerToolbox object
             */
            if (environment === void 0) { environment = null; }
            if (resolutionsConfig === void 0) { resolutionsConfig = null; }
            if (version === void 0) { version = 'prod'; }
            if (elementType === void 0) { elementType = null; }
            if (gaKEY === void 0) { gaKEY = null; }
            if (location === void 0) { location = ''; }
            if (flowProps === void 0) { flowProps = null; }
            if (setFlowConfigurationCallback === void 0) { setFlowConfigurationCallback = null; }
            if (quoteId === void 0) { quoteId = null; }
            if (setInsideWidgetQuoteId === void 0) { setInsideWidgetQuoteId = null; }
            if (isWidgetInWidget === void 0) { isWidgetInWidget = false; }
            if (cfx === void 0) { cfx = null; }
            if (theme === void 0) { theme = null; }
            if (origin === void 0) { origin = null; }
            if (isLocaleAphelia === void 0) { isLocaleAphelia = null; }
            if (initConfiguration === void 0) { initConfiguration = null; }
            if (standalone === void 0) { standalone = null; }
            var _this = this;
            /**
             * @desc Initialize simulator inside widget
             */
            this.onOpenSimulatorInWidget = function (event) {
                var _a, _b;
                _this.publishEvent('bss-remove-simulator-in-widget', { rowIndex: 1 }, false);
                _this.elementType = 'simulator';
                _this.isCompareFinance = true;
                _this.initFlowWithParams(_this.configData, (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.productType);
                _this.publishEvent('bss-run-simulator-in-widget', { rowIndex: 1 }, false);
            };
            /**
             * @desc Initialize simulator inside widget
             */
            this.onCompareFinanceInWidgetAph = function (event) {
                var _a, _b;
                if (_this.flowId !== '') {
                    _this.publishEvent('bss-remove-simulator-in-widget-aph', { self: _this }, true);
                    _this.elementType = 'compareFinance';
                    _this._insideWidgetQuoteId = null;
                    _this.isCompareFinance = true;
                    _this.setContainer('.bss-entity-container');
                    _this.initFlowWithParams(_this.configData, (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.productType);
                }
            };
            this.onStandaloneClick = function (event) {
                var _a, _b;
                _this.publishEvent('bss-remove-simulator-in-widget-aph', { self: _this }, true);
                _this.publishEvent('bss-select-compare-finance-standalone-product', { productType: (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.productType }, true);
                _this.destroyFlow();
            };
            /**
             * @desc Initialize simulator inside widget
             */
            this.onOpenSimulatorInWidgetAph = function (event) {
                var _a, _b;
                _this.publishEvent('bss-remove-simulator-in-widget-aph', { self: _this }, true);
                _this.elementType = 'simulator';
                _this.isCompareFinance = true;
                _this.setContainer('.bss-entity-container');
                _this.initFlowWithParams(_this.configData, (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.productType);
            };
            /**
             * @desc Remove simulator inside widget
             */
            this.onRemoveSimulatorInWidgetAph = function (event) {
                _this.destroyFlow();
            };
            _BSSControllerToolbox = new BSSControllerToolbox(environment, resolutionsConfig, version, marketComponents, descriptionConfig, flowProps, setFlowConfigurationCallback, quoteId, setInsideWidgetQuoteId, isWidgetInWidget, cfx, theme, origin, isLocaleAphelia, initConfiguration, standalone);
            _BSSControllerToolbox.elementType = elementType;
            _BSSControllerToolbox.setGAKey(gaKEY);
            _BSSControllerToolbox.location = location;
            //TODO analysis: where should be _eventManager and helper -> _BSSControllerToolbox work on the same EM object
            _eventManager = new EventManager();
            logger.info('Controller => constructor | Params: ', flowProps, environment, resolutionsConfig, logger.debugMode, version);
            if (!elementType) {
                _BSSControllerToolbox.getFlowConfiguration();
            }
            else if (elementType === 'stockCarsSimulator') {
                _BSSControllerToolbox.getFlowConfiguration({ elementType: elementType });
            }
        }
        Object.defineProperty(BSSController.prototype, "flowId", {
            get: function () {
                return _BSSControllerToolbox._flowId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BSSController.prototype, "elementType", {
            get: function () {
                return _BSSControllerToolbox.elementType;
            },
            set: function (value) {
                _BSSControllerToolbox.elementType = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BSSController.prototype, "isCompareFinance", {
            set: function (value) {
                _BSSControllerToolbox.isCompareFinance = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BSSController.prototype, "_insideWidgetQuoteId", {
            set: function (value) {
                _BSSControllerToolbox._insideWidgetQuoteId = value;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * @desc public method for setting entity params // Check if values are properly escaped.
         * @param {Object} [params=null] params - entity params to set
         * @param {Boolean} [overrideParamObj=false] overrideParamObj - when set to true 'params' parameter object override whole local params for given entity
         */
        BSSController.prototype.setParams = function (params, overrideParamObj) {
            if (params === void 0) { params = null; }
            if (overrideParamObj === void 0) { overrideParamObj = false; }
            logger.info('Controller => function: setParams | Params: ', params, overrideParamObj);
            _BSSControllerToolbox.setFlowParams(JSON.parse(_BSSControllerToolbox.ecs(JSON.stringify(params))), overrideParamObj);
        };
        /**
         * @desc get the initial data for current entity
         * @return {Object}
         */
        BSSController.prototype.getInitialEntityData = function () {
            logger.info('Controller => function: getInitialEntityData');
            return _BSSControllerToolbox.getInitialEntityData();
        };
        /**
         * @desc public method for setting initial call params for flow.
         * @param params
         * @param productType
         */
        BSSController.prototype.initFlowWithParams = function (params, productType) {
            if (params === void 0) { params = null; }
            if (productType === void 0) { productType = null; }
            logger.info('Controller => function: initFlowWithParams | Params: ', params);
            _BSSControllerToolbox.productType = productType;
            _BSSControllerToolbox.getFlowConfiguration(params);
        };
        BSSController.prototype.initFlowWithoutParams = function (standaloneCfTextsUrl) {
            if (standaloneCfTextsUrl === void 0) { standaloneCfTextsUrl = null; }
            logger.info('Controller => function: initFlowWithoutParams');
            _BSSControllerToolbox.setFlowConfigurationWithoutParams(standaloneCfTextsUrl);
        };
        /**
         * @desc public method for publishing event with event manager of toolbox
         * @param {string} eventName
         * @param {Object} data generic event data
         * @param {boolean} isPublic is event public
         */
        BSSController.prototype.publishEvent = function (eventName, data, isPublic) {
            if (eventName) {
                _BSSControllerToolbox._eventManager.publish(eventName, 'bss-connector', data, isPublic);
            }
        };
        /**
         * @desc setContainer public method for setting base flow entity container
         * @param {String} selector - entity container selector
         */
        BSSController.prototype.setContainer = function (selector) {
            logger.info('Controller => function: setContainer | Params: ', selector);
            _BSSControllerToolbox.setEntityContainer(selector);
        };
        /**
         * @desc setAdditionalContainer public method for setting additional flow entity container
         * @param {String} selector - additional entity container selector
         */
        BSSController.prototype.setAdditionalContainer = function (selector, externalId) {
            if (externalId === void 0) { externalId = 'externalBox'; }
            logger.info('Controller => function: setAdditionalContainer | Params: ', selector);
            _BSSControllerToolbox.setAdditionalContainer(selector, externalId);
        };
        /**
         * @desc setOptions public method for setting additional options
         * @param {Object} [options=null] options - additional options
         */
        BSSController.prototype.setOptions = function (options) {
            logger.info('Controller => function: setOptions | Params: ', options);
            _BSSControllerToolbox.setEntityOptions(options);
        };
        /**
         * @desc setInitOptions public method for setting additional options
         * @param {Object} [options=null] options - additional options
         */
        BSSController.prototype.setInitOptions = function (options) {
            logger.info('Controller => function: setInitOptions | Params: ', options);
            _BSSControllerToolbox.setInitOptions(options);
        };
        /**
         * @desc get inner overlay for current entity
         * @return {Object}
         */
        BSSController.prototype.getInnerEntityOverlay = function () {
            logger.info('Controller => function: getInnerEntityOverlay');
            return _BSSControllerToolbox.getInnerEntityOverlay();
        };
        /**
         * @desc get the default offer for current entity
         * @return {Object}
         */
        BSSController.prototype.getDefaultOffer = function () {
            logger.info('Controller => function: getDefaultOffer');
            return _BSSControllerToolbox.getDefaultOffer();
        };
        /**
         * @desc get the custom offer for current entity
         * @return {Object}
         */
        BSSController.prototype.getCustomOffer = function () {
            logger.info('Controller => function: getCustomOffer');
            return _BSSControllerToolbox.getCustomOffer();
        };
        /**
         * @desc create flow and initial entity - used in old, single entity flow
         */
        BSSController.prototype.createFlow = function () {
            logger.info('Controller => function: createFlow');
            this.setFlow();
            this.setEntity();
        };
        /**
         * @desc set flow - used in new version, for multiple entity per flow
         */
        BSSController.prototype.setFlow = function () {
            logger.info('Controller => function: setFlow');
            _BSSControllerToolbox.checkFlowConfiguration();
        };
        /**
         * @desc create entity with given order; if entityOrder is null, initial entity will be created
         * @param {Number} [entityOrder=null]
         */
        BSSController.prototype.setEntity = function (entityOrder) {
            if (entityOrder === void 0) { entityOrder = null; }
            logger.info('Controller => function: setEntity | Params: ', entityOrder);
            _BSSControllerToolbox.setEntity(entityOrder);
        };
        /**
         * @desc return current entity id
         * @return {*|String}
         */
        BSSController.prototype.getEntityId = function () {
            logger.info('Controller => function: getEntityId');
            return _BSSControllerToolbox.getCurrentEntityId();
        };
        /**
         * @desc return current entity instance id
         * @return {*|number}
         */
        BSSController.prototype.getEntityInstanceId = function () {
            logger.info('Controller => function: getEntityInstanceId');
            return _BSSControllerToolbox.getCurrentEntityInstanceId();
        };
        /**
         * @desc destroy flow - destroy all entities in the flow
         */
        BSSController.prototype.destroyFlow = function () {
            logger.info('Controller => function: destroyFlow');
            _BSSControllerToolbox.destroyFlow();
        };
        /**
         * @desc return current flow configuration
         * @return {*|String}
         */
        BSSController.prototype.getFlowConfiguration = function () {
            logger.info('Controller => function: getFlowConfiguration');
            var flowConfiguration = {};
            if (typeof _BSSControllerToolbox._flowConfiguration === 'object') {
                Object.assign(flowConfiguration, _BSSControllerToolbox._flowConfiguration);
            }
            return flowConfiguration;
        };
        /**
         * @desc retrieve value of parameter provided by integrator, user or calculated
         * @param {String} [setType=null] setType - type of offer
         * @param {String} [paramName=null] paramName - name of parameter
         * @return value of parameter provided by integrator
         */
        BSSController.prototype.getParam = function (setType, paramName) {
            if (setType === void 0) { setType = null; }
            if (paramName === void 0) { paramName = null; }
            logger.info('Controller => function: getParam | Params: ', setType, paramName);
            if (setType === null || paramName === null) {
                var errObj = {
                    entityInstanceId: this.getCurrentEntityInstanceId(),
                    errorMsg: 'Controller getParam error: parameters: "setType" and "paramName" are obligatory',
                };
                this._errorHandler(null, errObj);
            }
            _BSSControllerToolbox.checkFlowConfiguration();
            return _BSSControllerToolbox.getParam(setType, paramName);
        };
        return BSSController;
    }());
}
